export default {
  "fr": {
    "countries": {
      "ABW": "Aruba",
      "AFG": "Afghanistan",
      "AFI": "Afars et Issas",
      "AGO": "Angola",
      "AIA": "Anguilla",
      "ALA": "Îles Åland",
      "ALB": "Albanie",
      "AND": "Andorre",
      "ANT": "Antilles Néerlandaises",
      "ARE": "Emirats Arabes Unis",
      "ARG": "Argentine",
      "ARM": "Arménie",
      "ASM": "Samoa Americaines",
      "ATA": "Antarctique",
      "ATB": "Territoire britannique de l'Antarctique",
      "ATF": "Terres Australes Francaises",
      "ATG": "Antigua et Barbuda",
      "ATN": "Terre de la Reine Maud",
      "AUS": "Australie",
      "AUT": "Autriche",
      "AZE": "Azerbaïdjan",
      "BDI": "Burundi",
      "BEL": "Belgique",
      "BEN": "Bénin",
      "BES": "Bonaire, Saint-Eustache et Saba",
      "BFA": "Burkina Faso",
      "BGD": "Bangladesh",
      "BGR": "Bulgarie",
      "BHR": "Bahreïn",
      "BHS": "Bahamas",
      "BIH": "Bosnie-Herzégovine",
      "BLM": "Saint-Barthélemy",
      "BLR": "Bélarus",
      "BLZ": "Belize",
      "BMU": "Bermudes",
      "BOL": "Bolivie",
      "BRA": "Brésil",
      "BRB": "Barbade",
      "BRN": "Brunéi Darussalam",
      "BTN": "Bhoutan",
      "BUR": "Birma",
      "BVT": "Ile Bouvet",
      "BWA": "Botswana",
      "BYS": "Bélarus",
      "CAF": "Centrafricaine, République",
      "CAN": "Canada",
      "CCK": "Cocos (Keeling), Iles",
      "CHE": "Suisse",
      "CHL": "Chili",
      "CHN": "Chine",
      "CIV": "Cote d'Ivoire",
      "CMR": "Cameroun",
      "COD": "Congo",
      "COG": "Congo",
      "COK": "Iles Cook",
      "COL": "Colombie",
      "COM": "Comores",
      "CPV": "Cap-Vert",
      "CRI": "Costa Rica",
      "CSK": "Tchécoslovaquie",
      "CTE": "Îles Canton et Enderbury",
      "CUB": "Cuba",
      "CUW": "Curaçao",
      "CXR": "Christmas, Ile",
      "CYM": "Caïmanes,Îles",
      "CYP": "Chypre",
      "CZE": "Tcheque",
      "DDR": "Allemagne de l'Est",
      "DEU": "Allemagne",
      "DHY": "Dahomey",
      "DJI": "Djibouti",
      "DMA": "Dominique",
      "DNK": "Danemark",
      "DOM": "République Dominicaine",
      "DZA": "Algérie",
      "ECU": "Equateur",
      "EGY": "Egypte",
      "ERI": "Erythrée",
      "ESH": "Sahara occidental",
      "ESP": "Espagne",
      "EST": "Estonie",
      "ETH": "Ethiopie",
      "FIN": "Finlande",
      "FJI": "Fidji",
      "FLK": "Falkland, Iles (Malvinas)",
      "FRA": "France",
      "FRO": "Feroe, Iles",
      "FSM": "Micronésie",
      "FXX": "La France Métropolitaine",
      "GAB": "Gabon",
      "GBR": "Royaume-Uni",
      "GEL": "Îles Gilbert",
      "GEO": "Géorgie",
      "GGY": "Guernesey",
      "GHA": "Ghana",
      "GIB": "Gibraltar",
      "GIN": "Guinée",
      "GLP": "Guadeloupe",
      "GMB": "Gambie",
      "GNB": "Guinee-Bissau",
      "GNQ": "Guinée équatoriale",
      "GRC": "Grèce",
      "GRD": "Grenade",
      "GRL": "Groenland",
      "GTM": "Guatemala",
      "GUF": "Guyane Francaise",
      "GUM": "Guam",
      "GUY": "Guyana",
      "HKG": "Hong Kong",
      "HMD": "Île Heard et Îles Mcdonald",
      "HND": "Honduras",
      "HRV": "Croatie",
      "HTI": "Haïti",
      "HUN": "Hongrie",
      "HVO": "Haute-Volta",
      "IDN": "Indonésie",
      "IMN": "Ile de Man",
      "IND": "Inde",
      "IOT": "Territoire Britannique de l'Ocean Indien",
      "IRL": "Irlande",
      "IRN": "Iran",
      "IRQ": "Iraq",
      "ISL": "Islande",
      "ISR": "Israël",
      "ITA": "Italie",
      "JAM": "Jamaïque",
      "JEY": "Jersey",
      "JOR": "Jordanie",
      "JPN": "Japon",
      "JTN": "Île Johnston",
      "KAZ": "Kazakhstan",
      "KEN": "Kenya",
      "KGZ": "Kirgisistan",
      "KHM": "Cambodge",
      "KIR": "Kiribati",
      "KNA": "Sankt Kitts, Nevis et Anguilla",
      "KOR": "Corée du Sud",
      "KWT": "Koweït",
      "LAO": "Lao",
      "LBN": "Liban",
      "LBR": "Libéria",
      "LBY": "Libye",
      "LCA": "Sainte-Lucie",
      "LIE": "Liechtenstein",
      "LKA": "Sri Lanka",
      "LSO": "Lesotho",
      "LTU": "Lituanie",
      "LUX": "Luxembourg",
      "LVA": "Lettonie",
      "MAC": "Macao",
      "MAF": "Saint-Martin (partie française)",
      "MAR": "Maroc",
      "MCO": "Monaco",
      "MDA": "Moldova",
      "MDG": "Madagascar",
      "MDV": "Maldives",
      "MEX": "Mexique",
      "MHL": "Iles Marshal",
      "MID": "Îles Midway",
      "MKD": "Macédoine",
      "MLI": "Mali",
      "MLT": "Malte",
      "MMR": "Myanmar",
      "MNE": "Monténégro",
      "MNG": "Mongolie",
      "MNP": "Iles Mariannes du Nord",
      "MOZ": "Mozambique",
      "MRT": "Mauritanie",
      "MSR": "Montserrat",
      "MTQ": "Martinique",
      "MUS": "Maurice",
      "MWI": "Malawi",
      "MYS": "Malaisie",
      "MYT": "Mayotte",
      "NAM": "Namibie",
      "NCL": "Nouvelle-Calédonie",
      "NER": "Niger",
      "NFK": "Ile de Norfolk",
      "NGA": "Nigéria",
      "NHB": "Nouvelles-Hébrides",
      "NIC": "Nicaragua",
      "NIU": "Niue",
      "NLD": "Pays-Bas",
      "NOR": "Norvège",
      "NPL": "Népal",
      "NRU": "Nauru",
      "NTZ": "Zone neutre",
      "NZL": "Nouvelle-Zélande",
      "OMN": "Oman",
      "PAK": "Pakistan",
      "PAN": "Panama",
      "PCI": "Îles Du Pacifique (Territoire Sous Tutelle)",
      "PCN": "Pitcairn",
      "PCZ": "Zone du canal de Panama",
      "PER": "Pérou",
      "PHI": "Philippines",
      "PHL": "Philippines",
      "PLW": "Palaos",
      "PNG": "Papouasie-Nouvelle-Guinée",
      "POL": "Pologne",
      "PRI": "Porto Rico",
      "PRK": "Corée du Nord",
      "PRT": "Portugal",
      "PRY": "Paraguay",
      "PSE": "Palestinien Occupé, Territoire",
      "PUS": "Diverses îles du Pacifique (Etats-Unis)",
      "PYF": "Polynesie Francaise",
      "QAT": "Qatar",
      "REU": "Réunion",
      "RHO": "Rhodésie du sud",
      "ROU": "Roumanie",
      "RUS": "Russie",
      "RWA": "Rwanda",
      "SAU": "Arabie Saoudite",
      "SCG": "Serbie-et-Monténégro",
      "SDN": "Soudan",
      "SEN": "Sénégal",
      "SGP": "Singapour",
      "SGS": "Géorgie du Sud et les Îles Sandwich du Sud",
      "SHN": "Sainte-Hélène, Ascension et Tristan da Cunha",
      "SJM": "Svalbard et Île Jan Mayen",
      "SKM": "Sikkim",
      "SLB": "Iles de Salomon",
      "SLE": "Sierra Leone",
      "SLV": "El Salvador",
      "SMR": "Saint-Marin",
      "SOM": "Somalie",
      "SPM": "Saint-Pierre-et-Miquelon",
      "SRB": "Serbie",
      "SSD": "Soudan du Sud",
      "STP": "Sao Tome-et-Principe",
      "SUN": "URSS",
      "SUR": "Suriname",
      "SVK": "Slovaquie",
      "SVN": "Slovénie",
      "SWE": "Suède",
      "SWZ": "Swaziland",
      "SXM": "Saint-Martin (partie néerlandaise)",
      "SYC": "Seychelles",
      "SYR": "Syrie",
      "TCA": "Turques-et-Caïques, Îles",
      "TCD": "Tchad",
      "TGO": "Togo",
      "THA": "Thaïlande",
      "TJK": "Tadjikistan",
      "TKL": "Tokelau",
      "TKM": "Turkménistan",
      "TLS": "Timor-Oriental",
      "TMP": "Timor portugais",
      "TON": "Tonga",
      "TTO": "Trinité-et-Tobago",
      "TUN": "Tunisie",
      "TUR": "Turquie",
      "TUV": "Tuvalu",
      "TWN": "Taiwan, Province de Chine",
      "TZA": "Tanzanie",
      "UGA": "Ouganda",
      "UKR": "Ukraine",
      "UMI": "Îles mineures éloignées des Etats-Unis",
      "URY": "Uruguay",
      "USA": "Etats-Unis",
      "UZB": "Ouzbékistan",
      "VAT": "Saint-Siege",
      "VCT": "Saint-Vincent-et-les Grenadines",
      "VDR": "Nord-Vietnam",
      "VEN": "Venezuela",
      "VGB": "Îles Vierges britanniques",
      "VIR": "Îles Vierges des Etats-Unis",
      "VNM": "Sud-Vietnam",
      "VUT": "Vanuatu",
      "WAK": "Île De Wake",
      "WLF": "Wallis et Futuna",
      "WSM": "Samoa",
      "XXX": "Inconnu",
      "YEM": "Yémen du Nord",
      "YMD": "Yémen du Sud",
      "YUG": "Yougoslavie",
      "ZAF": "Afrique du Sud",
      "ZAR": "Zaïre",
      "ZMB": "Zambie",
      "ZWE": "Zimbabwe"
    }
  }
}